import React, {useEffect, useState } from 'react';
import useJason from "./useJason";

const JasonLearn = () => {

/*
    const [color, setColor] = useState("red");

    return (
      <>
        <h1>My favorite color is {color}!</h1>
        <button
          type="button"
          onClick={() => setColor("blue")}
        >Blue</button>
        <button
          type="button"
          onClick={() => setColor("red")}
        >Red</button>
        <button
          type="button"
          onClick={() => setColor("pink")}
        >Pink</button>
        <button
          type="button"
          onClick={() => setColor("green")}
        >Green</button>
      </>
     );
    };export default JasonLearn */
    

    const [workers, setWorkers] = useState([]);
    const [batch, setBatch] = useState([]);
    const [batchName, setBatchName] = useState('unknown');
    const [data] = useJason('SelectedBatch')
    // get the workers
    //setWorkers("JASON")
    //read the topmenu to get the selected batch
    
    
/*
    console.log({workers})
    useEffect(() => {
        var BatchName 
        BatchName = GetSelectedBatchName();
        console.log(BatchName)
        setBatchName(BatchName)
    }, [batch])
    console.log({batch})
    */
   
    return (<div>
    
        <div>The batchName is: {data}</div>
        <div>The batch is: {batch}</div>
        <div>The workers are: {workers}</div>
        </div>)
};export default JasonLearn 


